import { BasicsClass } from "@/common/BasicsClass";
import { Util } from "@/common/util";

import { CommonApi } from "../common";

export class AllinpayTransferRecordAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getAllinpayTransferRecordList', {
      url: '/admin/allinpay/lists',
      name: 'list',
      label: '列表'
    }],
    // ['exportExcelMemberConsumeList', {
    //   url: '/admin/member/exportDecreaseMemberList',
    //   name: 'export-excel',
    //   label: '导出'
    // }],
    ['getAllinPlatformAccountInfo', {
      url: '/admin/allinpay/balance',
      name: 'allinpay-balance-info',
      label: '通联账户余额信息'
    }],

    ['allinpayTransferMoney', {
      url: '/admin/allinpay/transfer',
      name: 'allinpy-transfer-money',
      label: '通联支付划转金额'
    }],
  ])
  // 订单api 方法
  // 通联资金划转记录列表
  public getAllinpayTransferRecordList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {

    console.log(params, "params");

    const apiUrls = this.apiUrls

    const url = apiUrls.get('getAllinpayTransferRecordList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 通联账户余额信息
  public getAllinPlatformAccountInfo(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {

    console.log(params, "params");

    const apiUrls = this.apiUrls

    const url = apiUrls.get('getAllinPlatformAccountInfo').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

 
  // // 导出全国会员扣款记录列表
  // public exportExcelMemberConsumeList(
  //   params: any,
  //   successCb: Function,
  //   failCb: Function,
  //   showLoading: boolean = false
  // ) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('exportExcelMemberConsumeList').url

  //   this.BasicPost(url, {
  //     ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 通联支付划转金额
  public allinpayTransferMoney(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('allinpayTransferMoney').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
}
